import React from 'react';
import ReactApexChart from 'react-apexcharts';

export default function DashboardChart({ series, xlabel, ylabel, xCategories, title }) {
  const options = {
    title: {
      show: title,
      text: title,
      align: 'center',
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#333',
      },
    },
    chart: {
      id: 'basic-bar',
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
      position: 'top',
      fontSize: 15,
      itemMargin: {
        horizontal: 25,
      },
      markers: {
        size: 12,
      },
    },
    xaxis: {
      position: 'bottom',
      categories: xCategories,
      title: {
        text: 'Month',
        offsetX: 10,
        style: {
          fontSize: '14px',
          fontWeight: '700',
          color: '#555',
        },
      },

      labels: {
        rotate: -45,
        rotateAlways: true,
        style: {
          fontSize: '12px',
          colors: ['#555'],
        },
      },
    },
    yaxis: {
      max: (max) => max + max * 0.2,
      title: {
        text: 'Response',
        style: {
          fontWeight: '700',
          color: '#555',
          fontSize: '14px',
        },
      },
    },
    colors: ['#5083ea', '#d7503c'],
  };

  return <ReactApexChart options={options} series={series} type={'bar'} width={'100%'} />;
}
